<template>
  <div>
    <div v-if="isPC" class="main">
      <h3 class="page-title">{{$t('commodity.PaymentStatus.Payment')}}</h3>
      <!-- 成功 -->
      <div v-if="query.state === 'success' || query.interactionCode === 'PROCEED'" class="successful-box bg-white">
        <div class="icon f-c-c">
          <i class="iconfont icon-check-line"></i>
        </div>
        <h3 class="status-text">{{$t('commodity.PaymentStatus.PaymentSuccessful')}}</h3>
        <div class="f-c" style="margin-bottom: 54px">
          <el-button style="height: 45px" @click="checkOrder">{{$t('commodity.PaymentStatus.CheckOrder')}}</el-button>
          <el-button type="primary" style="height:45px" @click="$router.push('/mall/shoppingCar')" v-if="!($route.query.payPage && $route.query.payPage === 'custom')">{{$t('commodity.PaymentStatus.BackToShoppingBag')}}</el-button>
        </div>
        <div class="order">
          <h5>{{$t('commodity.PaymentStatus.Order')}}</h5>
          <div v-if="query.interactionReason" class="info f fw-w">
            <p>{{$t('commodity.PaymentStatus.OrderID')}}：{{query.orderId}}</p>
            <p>{{$t('commodity.PaymentStatus.PaymentAmount')}}：${{query.amount}}</p>
            <p>{{$t('commodity.PaymentStatus.PaymentMethod')}}：Payoneer</p>
          </div>
          <div v-else class="info f fw-w">
            <p v-if="query.storeOrderId">{{$t('commodity.PaymentStatus.StoreOrderID')}}：{{query.storeOrderId}}</p>
            <p>{{$t('commodity.PaymentStatus.OrderID')}}：{{query.orderId}}</p>
            <p>{{$t('commodity.PaymentStatus.Source')}}：{{$t('commodity.PaymentStatus.ShopifyRtoiweuuyir')}}</p>
            <p>{{$t('commodity.PaymentStatus.PaymentTime')}}：{{paymentTime}}</p>
            <p>{{$t('commodity.PaymentStatus.PaymentAmount')}}：${{query.paymentAmount}}</p>
            <p>{{$t('commodity.PaymentStatus.PaymentMethod')}}：
              <template v-if="query.paymentMethod == 0">{{$t('commodity.PaymentStatus.Balance')}}</template>
              <template v-if="query.paymentMethod == 4">{{$t('commodity.PaymentStatus.CreditCard')}}</template>
              <template v-if="query.paymentMethod == 2">{{$t('commodity.PaymentStatus.Paypal')}}</template>
              <template v-if="query.paymentMethod == 3">{{$t('commodity.PaymentStatus.Others')}}</template>
            </p>
          </div>
        </div>
        <div class="timeline">
          <p class="timeline-text">{{$t('commodity.PaymentStatus.EverySingleProductGoesThroughOurRigorousQualityInspectionBeforeWeSendItToYourCustomers')}}</p>
          <div class="timeline-list f">
            <div class="item">
              <div class="circular bg-green"></div>
              <p class="text">{{$t('commodity.PaymentStatus.OrderCreation')}}</p>
              <p class="date color-gray">{{paymentTime}}</p>
            </div>
            <div class="line bg-green"></div>

            <div class="item">
              <div class="circular bg-green"></div>
              <p class="text">{{$t('commodity.PaymentStatus.PaymentSuccessful')}}</p>
              <p class="date color-gray">{{paymentTime}}</p>
            </div>
            <div class="line bg-gray"></div>

            <div class="item">
              <div class="circular bg-gray"></div>
              <p class="text color-gray">{{$t('commodity.PaymentStatus.Shipped')}}</p>
            </div>
            <div class="line bg-gray"></div>

            <div class="item">
              <div class="circular bg-gray"></div>
              <p class="text color-gray">{{$t('commodity.PaymentStatus.Complete')}}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 失败 -->
      <div v-else class="successful-box bg-white">
        <div class="icon f-c-c" style="background: #A6100C;">
          <i class="iconfont icon-a-close-line1"></i>
        </div>
        <h3 class="status-text" style="padding-bottom: 0px;">{{$t('commodity.PaymentStatus.PaymentFail')}}</h3>
        <!-- <p class="failure-reason">Your bank card balance is insufficient</p> -->

        <div class="f-c-c" style="padding: 15px 0 35px;">
          <router-link to="/order/list" replace>
            <el-button size="mini">{{$t('commodity.PaymentStatus.Back')}}</el-button>
          </router-link>
          <!-- <el-button size="mini" style="margin-left: 24px;">Retry</el-button> -->
        </div>
        <div class="order">
          <div v-if="query.interactionReason" class="info f">
            <p>{{$t('commodity.PaymentStatus.Order')}}: {{query.orderId}}</p>
            <p>{{$t('commodity.PaymentStatus.PaymentMethod')}}：Payoneer</p>
            <p>Failure code：{{ query.interactionReason }}</p>
          </div>
          <div v-else class="info f">
          <h5>{{$t('commodity.PaymentStatus.Order')}}</h5>
            <p v-if="query.storeOrderId">{{$t('commodity.PaymentStatus.StoreOrderID')}}：{{query.storeOrderId}}</p>
            <p>{{$t('commodity.PaymentStatus.Order')}} {{query.orderId}}</p>
            <p>{{$t('commodity.PaymentStatus.Source')}}：{{$t('commodity.PaymentStatus.ShopifyRtoiweuuyir')}}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 移动端 -->
    <div v-else class="mobile-payment">
      <div class="icon-img f-c-c" :style="{backgroundColor:query.state === 'success' || query.interactionCode === 'PROCEED'?'#99C41C':'#A6100C'}">
        <i class="iconfont" :class="[query.state === 'success' || query.interactionCode === 'PROCEED' ? 'icon-check-line' : 'icon-a-close-line1']"></i>
      </div>
      <div class="payment-title f-c">{{query.state === 'success' || query.interactionCode === 'PROCEED' ? 'Payment Successful' : 'Payment Fail'}}</div>
      <div class="payment-main">
        <div class="title">{{$t('commodity.PaymentStatus.Order')}}</div>
        <div v-if="query.storeOrderId" class="item">
          <div class="item-label">{{$t('commodity.PaymentStatus.StoreOrderID')}}</div>
          <div class="item-text">{{query.storeOrderId}}</div>
        </div>
        <div v-if="query.state === 'success' || query.interactionCode === 'PROCEED'">
          <template v-if="query.interactionReason">
            <div class="item">
              <div class="item-label">{{$t('commodity.PaymentStatus.OrderID')}}</div>
              <div class="item-text">{{query.orderId}}</div>
            </div>
            <div class="item">
              <div class="item-label">{{$t('commodity.PaymentStatus.PaymentMethod')}}</div>
              <div class="item-text">Payoneer</div>
            </div>
          </template>
          <template v-else>
            <div class="item">
              <div class="item-label">{{$t('commodity.PaymentStatus.OrderID')}}</div>
              <div class="item-text">{{query.orderId}}</div>
            </div>
            <div class="item">
              <div class="item-label">{{$t('commodity.PaymentStatus.PaymentTime')}}</div>
              <div class="item-text">{{paymentTime}}</div>
            </div>
            <div class="item">
              <div class="item-label">{{$t('commodity.PaymentStatus.PaymentAmount')}}</div>
              <div class="item-text">US ${{query.paymentAmount}}</div>
            </div>
            <div class="item">
              <div class="item-label">{{$t('commodity.PaymentStatus.PaymentMethod')}}</div>
              <div class="item-text">
                <template v-if="query.paymentMethod == 0">{{$t('commodity.PaymentStatus.Balance')}}</template>
                <template v-if="query.paymentMethod == 4">{{$t('commodity.PaymentStatus.CreditCard')}}</template>
                <template v-if="query.paymentMethod == 2">{{$t('commodity.PaymentStatus.Paypal')}}</template>
                <template v-if="query.paymentMethod == 3">{{$t('commodity.PaymentStatus.Others')}}</template>
              </div>
            </div>
          </template>
        </div>
        <div v-else>
          <template v-if="query.interactionReason">
            <div class="item">
              <div class="item-label">{{$t('commodity.PaymentStatus.OrderID')}}</div>
              <div class="item-text">{{query.orderId}}</div>
            </div>
            <div class="item">
              <div class="item-label">{{$t('commodity.PaymentStatus.PaymentMethod')}}</div>
              <div class="item-text">Payoneer</div>
            </div>
            <div class="item">
              <div class="item-label">Failure code：</div>
              <div class="item-text">{{ query.interactionReason }}</div>
            </div>
          </template>
          <div class="item" v-else>
            <div class="item-label">{{$t('commodity.PaymentStatus.OrderID')}}</div>
            <div class="item-text">{{query.orderId}}</div>
          </div>
        </div>

        <el-button class="mobile-payment-status-gohome" type="primary" @click="$router.replace('/order/list')">{{$t('commodity.PaymentStatus.ViewOrder')}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { dateFormat } from '@/util/date'
import API from '@/api'
export default {
  data() {
    return {
      paymentTime: ''
    }
  },
  computed: {
    query() {
      return this.$route.query
    }
  },
  created() {
    this.paymentTime = dateFormat()
    if (!this.query.longId) this.getOrderState()
    window.gtag('event', 'thank_you', {
      // send_to: 'AW-10858456197/scUoCKu3_4AYEIXJ27ko',
      value: +this.query.paymentAmount,
      currency: 'USD',
      transaction_id: this.query.orderId
    })
  },
  mounted() {
    if (this.query.longId) {
      API.getPayoneerCallback(this.query.longId)
    }
  },
  methods: {
    // 更新订单状态
    getOrderState() {
      API.getOrderState(this.query.orderId)
    },
    checkOrder() {
      if (this.$route.query.payPage && this.$route.query.payPage === 'custom') {
        this.$router.push('/commodity/CustomProduct/list')
        return
      }
      this.$router.push('/order/list')
      // https://kakatest.com/payment-status?listUrl=https%3A%2F%2Fapi.sandbox.oscato.com%2Fpci%2Fv1%2F66568804df84eb0001835207ljjtoij7jd30mmvf1dn624r799&shortId=08743-26110&customerRegistrationId=6655d374a18876000adbe538u&interactionReason=OK&resultCode=00000.WORLDPAY-ACCESS.Sent%20for%20Settlement&longId=665688406b1e61000162564cc&transactionId=1000001547604&interactionCode=PROCEED&amount=30.91&reference=1000002513930&currency=USD
      // listUrl=https%3A%2F%2Fapi.sandbox.oscato.com%2Fpci%2Fv1%2F6656cb29df84eb0001835738l0q8hrtoiqj4q0d13dp9u4c7r3&shortId=05503-63890&customerRegistrationId=6655d374a18876000adbe538u&interactionReason=RISK_DETECTED&resultCode=45408.WORLDPAY-ACCESS.34&longId=6656cb4adf84eb000183573bc&transactionId=1000001548886&interactionCode=ABORT
    }
  }
}
</script>

<style lang="scss" scoped>
.page-title{
  line-height: 65px;
  font-weight: 500;
  font-size: 18px;
}
.successful-box{
  overflow: hidden;
  padding-top: 70px;
  .icon{
    width: 70px;
    height: 70px;
    margin: 0 auto;
    background: #99C41C;
    color: white;
    border-radius: 100px;
    i{
      font-size: 40px;
    }
  }
  .status-text{
    text-align: center;
    font-size: 24px;
    line-height: 43px;
    font-weight: 500;
    padding-top: 20px;
    padding-bottom: 40px;
  }
  .failure-reason{
    text-align: center;
    color: #A6100C;
    font-size: 16px;
    line-height: 43px;
  }
  .order{
    padding: 25px 130px;
    border-top: solid 1px #F5F7F7;

    h5{
      font-size: 16px;
      font-weight: 500;
      line-height: 28px;
    }
    .info{
      p{
        flex-shrink: 0;
        width: 33%;
        font-size: 14px;
        line-height: 24px;
        color: #747A87;
      }
    }
  }
}
.timeline{
  border-top: 14px solid #F5F7F7;
  padding: 20px 124px 36px 124px;
  .timeline-text{
    font-size: 14px;
    line-height: 21px;
  }
  .timeline-list{
    padding-top: 25px;
    .item{
      padding-left: 12px;
      position: relative;
      .date{
        font-size: 13px;
      }
    }
    .line{
      width: 100px;
      height: 1px;
      margin: 10px 5px;
    }
  }
  .bg-green{
    background: #99C41C;
  }
  .bg-gray{
    background: #8B93A3;
  }
  .color-gray{
    color: #8B93A3;
  }
  .circular{
    border-radius: 100px;
    width: 8px;
    height: 8px;
    position: absolute;
    top: 6px;
    left: 0;
  }
}
</style>

<style lang="scss" scoped>
.mobile-payment {
  box-sizing: border-box;
  padding: 1rem 0.4rem 0 0.4rem;
  min-height: 100%;
  background-color: #fff;
  min-height: calc(100vh - 0.86rem);

  .icon-img {
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 50%;
    background-color: #99C41C;
    margin: 0 auto;

    .iconfont {
      font-size: .8rem;
      color: #fff;
    }
  }

  .payment-title {
    font-size: .36rem;
    line-height: 1.2rem;
  }

  .payment-main {
    margin-top: .4rem;

    .title{
      font-size: .32rem;
    }

    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: .24rem 0;
      margin-top: .08rem;
      border-bottom: .01rem solid #DEDEDE;
    }
  }
}
.mobile-payment-status-gohome{
  position: fixed;
  bottom: .6rem;
  left: calc(50vw - 2.45rem);
  width: 4.9rem;
}
</style>
